import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

//fetch coach profile
export const getCoachProfileByEmailIdApi = async (emailId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_COACH_PROFILE_BY_EMAIL_ID}${emailId}`
    );

    return response?.data;
  } catch (error) {
    throw error;
  }
};

//fetch coach profile
export const getCoachProfileByCoachIdApi = async (coachId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_COACH_PROFILE_BY_COACH_ID}${coachId}`
    );
    return response?.data;
  } catch (error) {
    throw error.data;
  }
};

// Upsert coach profile
export const updateCoachProfileApi = async (payload) => {
  const response = await axiosInstance.post(
    Endpoints.UPDATE_COACH_PROFILE,
    payload
  );
  return response?.data?.data;
};
